import React from 'react';
import loading from './asset/loading.svg';
import dl from './asset/dl.svg';
import check from './asset/check.svg';
import help from './asset/help.svg';
import S from './PlanningFooter.module.scss';

type PlanningFooterProps = {
  handleClick: () => void;
  savingState: number;
};

const PlanningFooter = ({ handleClick, savingState }: PlanningFooterProps) => {
  const getSaveButtonContent = () => {
    switch (savingState) {
      case 1:
        return (
          <>
            Enregistrement
            <img src={loading} alt="logo de chargement" className={S.loading} />
          </>
        );
      case 2:
        return (
          <>
            Enregistré
            <img src={check} alt="logo de validation" className={S.icon} />
          </>
        );
      case 0:
      default:
        return (
          <>
            Enregistrer
            <img src={dl} alt="logo d'enregistrement" className={S.icon} />
          </>
        );
    }
  };

  const getSaveButtonClass = () => {
    const baseClass = S.saveButton;
    switch (savingState) {
      case 1:
        return `${baseClass} ${S.saving}`;
      case 2:
        return `${baseClass} ${S.saved}`;
      case 0:
      default:
        return `${baseClass} ${S.default}`;
    }
  };

  return (
    <div className={S.container}>
      <label className={S.helpLabel}>
        <img src={help} alt="logo d'aide" />
        <span>Aide</span>
      </label>

      <div className={S.content}>
        <div className={S.buttonContainer}>
          <button
            className={getSaveButtonClass()}
            onClick={handleClick}
            disabled={savingState !== 0}
          >
            {getSaveButtonContent()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanningFooter;
